angular.module("app")

.factory('treeService', ['$injector', function ($injector) {


    let service = {
        menuTree: function (menusItems, menuItemId, treeMenusItems) {
            let $l1 = [];


            function pintarRecursivo($actual, level) {

                if ($actual.parent_menu_item_id == null) $actual.$$treeLevel = level;                
                treeMenusItems.push($actual);
                angular.forEach(menusItems, function (menuItem) {
                    if (menuItem.parent_menu_item_id == $actual.id) {
                        //recorremos el treeMenusItems para decir que ya no es ultimo.
                        angular.forEach(treeMenusItems, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(menuItem, level + 1);
                    }
                });
            };


            //Obtenemos los padres
            angular.forEach(menusItems, function (menuItem) {

                if (menuItem.parent_menu_item_id == null) {
                    if (menuItem.id != null) {
                        $l1.push(menuItem);
                    }                   
                }

            });

            //Pintamos
            angular.forEach($l1, function (menuItemParent) {

                pintarRecursivo(menuItemParent, 0);
            });

            return treeMenusItems;
        },

        languageTree: function (resourcesItem, language_id) {
            let treeLanguagesItems = [];

            //Obtenemos los padres
            let nombreModulo = "";
            for (let i = 0; i < resourcesItem.length; i++ ){
                let itemId = resourcesItem[i];
                let itemNuevo: any = {};
                if (itemId.module != nombreModulo) {
                    itemNuevo.module = itemId.module;
                    itemNuevo.isParent = 1;
                    itemNuevo.value = "";
                    itemNuevo.code = "";
                    itemNuevo.FK_resources_tl_resources = [];
                    itemNuevo.$$treeLevel = 0;
                    itemNuevo.id = "";
                    treeLanguagesItems.push(itemNuevo);
                    for (i; i < resourcesItem.length; i++) {
                        let item = resourcesItem[i];
                        if (item.module == itemNuevo.module) {

                            item.isParent = 0;
                            item.language_id = language_id;
                            item.resource_id = item.id;
                            angular.forEach(item.FK_resources_tl_resources, function (m) {
                                if (m.language_id == language_id) {
                                    item.value = m.value;
                                    item.FK_resources_tl_resources_id = m.id;
                                }
                            });
                            treeLanguagesItems.push(item);
                        } else {
                            i--;
                            break;
                        }

                    }
                }
                nombreModulo = itemId.module;
            }
           
            return treeLanguagesItems;
        },

        groups: function (groups, menuItemId, showOrder) {
            let $l1 = [];
            let treeGroups = [];
            let blankBlock = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";

            function pintarRecursivo($actual, level, super_parent_id) {

                $actual.$$treeLevel = level;
                $actual.super_parent_id = super_parent_id;

                let auxmargin = level * 15;
                let blankBlockLevel = ".";

                let priorityText = "";
                if($actual.priority != null) {
                    priorityText = $actual.priority + ". ";
                }
                if (showOrder)
                    $actual.customName = '<span style="margin-left: ' + auxmargin + 'px; background-color:' + $actual.color + ';font-size: 15px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;' + priorityText + " (" +  $actual.preferred_order + ") " + $actual.name;
                else
                    $actual.customName = '<span style="margin-left: ' + auxmargin + 'px; background-color:' + $actual.color + ';font-size: 15px;">&nbsp;&nbsp;&nbsp;&nbsp;</span>&nbsp;' + priorityText + $actual.name;

                for (let i = 0; i <= level;i++){
                    blankBlockLevel += "   ";
                }
                $actual.customNamePDF = blankBlockLevel + "" + $actual.name;
                treeGroups.push($actual);
                angular.forEach(groups, function (group) {
                    angular.forEach(group.FK_groups_groups_groups1, function (group_group) {
                        if (group_group.parent_group_id == $actual.id) {
                           
                            return pintarRecursivo(angular.copy(group), level + 1, super_parent_id);
                        }
                    });
                });
            };

            //Obtenemos los padres
            $l1 = _.filter(groups, function (group) { return group.FK_groups_groups_groups1.length == 0; })          
            //Pintamos
            angular.forEach($l1, function (groupItemParent) {
                let super_parent_id = groupItemParent.id;
                pintarRecursivo(angular.copy(groupItemParent), 0, super_parent_id);
            });

            return treeGroups;
        },

        // Paises y regiones

        countries: function (countries, ccountryId, treeCountries) {
            let $l1 = [];

            function pintarRecursivo($actual, level) {
                $actual.$$treeLevel = level;
                treeCountries.push($actual);
                angular.forEach(countries, function (country) {

                angular.forEach(country.FK_countries_regions_countries, function (region) {
                        pintarRecursivo(region, level + 1);

                        });
 

                });
            };

            //Obtenemos los padres
            angular.forEach(countries, function (country) {

                    if (country.id != null) {
                        $l1.push(country);
                    }
  
            });

            //Pintamos
            angular.forEach($l1, function (countryParent) {

                pintarRecursivo(countryParent, 0);
            });

            return treeCountries;
        },
//
        indicators: function (indicators) {
            let treeIndicatorsItems = [];

            let $filter = $injector.get("$filter");

            //Obtenemos los padres
            let nombreModulo = "";
            for (let i = 0; i < indicators.length; i++) {
                let itemId = indicators[i];
                let itemNuevo: any = {};
                if (itemId.FK_events_indicators_staff.name == null)
                    itemId.FK_events_indicators_staff.name = $filter('translate')('events.indicators_types.no_person');

                if (itemId.FK_events_indicators_staff.name != nombreModulo) {
                    itemNuevo.FK_events_indicators_staff = {
                        name: itemId.FK_events_indicators_staff.name
                    };
                    itemNuevo.isParent = 1;
                    itemNuevo.$$treeLevel = 0;
                    treeIndicatorsItems.push(itemNuevo);

                    for (i; i < indicators.length; i++) {
                        let item = indicators[i];
                        if (item.FK_events_indicators_staff.name == null)
                            item.FK_events_indicators_staff.name = $filter('translate')('events.indicators_types.no_person');
                        if (item.FK_events_indicators_staff.name == itemNuevo.FK_events_indicators_staff.name) {
                            item.isParent = 0;
                            treeIndicatorsItems.push(item);
                        } else {
                            i--;
                            break;
                        }
                    }
                }
                nombreModulo = itemId.FK_events_indicators_staff.name;
            }

            return treeIndicatorsItems;
        },

        eventTasksTree: function (eventTasks, eventTaskId, treeEventTasks) {
            let $l1 = [];            

            function pintarRecursivo($actual, level) {                
                if ($actual.event_task_id == null && $actual.is_group) $actual.$$treeLevel = level;
                $actual.hasTasks = false;
                treeEventTasks.push($actual);
                
                angular.forEach(eventTasks, function (eventTask) {                    
                    if (eventTask.event_task_id == $actual.id && eventTask.id != null && !eventTask.is_group) {                        
                        $actual.hasTasks = true;                                                
                        //recorremos el tree para decir que ya no es ultimo.
                        angular.forEach(treeEventTasks, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(eventTask, level + 1);
                    }
                });
            };


            let otherGroup = "";
            //Obtenemos los padres            
            angular.forEach(eventTasks, function (eventTask) {                
                if (eventTask.is_group) {
                    if (eventTask.id != null) {
                        $l1.push(eventTask);
                    } else {
                        otherGroup = eventTask;
                    }                
                }
            });

            if (eventTasks.length > 0 && otherGroup != "") $l1.push(otherGroup);

            //Pintamos
            angular.forEach($l1, function (eventTaskParent) {                
                pintarRecursivo(eventTaskParent, 0);
            });

            return treeEventTasks;
        },

        typesMaterialsTree: function (typesMaterials, typeMaterialId, treeTypesMaterials) {
            let $l1 = [];


            function pintarRecursivo($actual, level) {
                if ($actual.material_type_id == null && $actual.is_group) $actual.$$treeLevel = level;
                treeTypesMaterials.push($actual);
                angular.forEach(typesMaterials, function (typeMaterial) {
                    if (typeMaterial.material_type_id == $actual.id && typeMaterial.id != null && !typeMaterial.is_group) {
                        //recorremos el tree para decir que ya no es ultimo.
                        angular.forEach(treeTypesMaterials, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(typeMaterial, level + 1);
                    }
                });
            };

            let otherGroup = "";
            //Obtenemos los padres
            angular.forEach(typesMaterials, function (typeMaterial) {

                if (typeMaterial.is_group) {
                    if (typeMaterial.id != null) {
                        $l1.push(typeMaterial);
                    } else {
                        otherGroup = typeMaterial;
                    }
                }

            });
            $l1.push(otherGroup);

            //Pintamos
            angular.forEach($l1, function (typeMaterialParent) {

                pintarRecursivo(typeMaterialParent, 0);
            });

            return treeTypesMaterials;
        },


        locationsTree: function (locations, locationId, treeLocations) {
            let $l1 = [];


            function pintarRecursivo($actual, level) {
                if ($actual.parent_location_id == null) $actual.$$treeLevel = level;
                treeLocations.push($actual);
                angular.forEach(locations, function (location) {
                    if (location.parent_location_id == $actual.id && location.id != null) {
                        //recorremos el tree para decir que ya no es ultimo.
                        angular.forEach(treeLocations, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(location, level + 1);
                    }
                });
            };

            let otherGroup = "";
            //Obtenemos los padres
            angular.forEach(locations, function (location) {

                if (location.parent_location_id==null) {
                    if (location.id != null) {
                        $l1.push(location);
                    } 
                }

            });

            //Pintamos
            angular.forEach($l1, function (locationParent) {

                pintarRecursivo(locationParent, 0);
            });

            return treeLocations;
        },

        //Arbol de categorías

        cmsCategoriesTree: function (cms_categories, cmsCategoryId, treeCmsCategories) {
            let $l1 = [];

            function pintarRecursivo($actual, level) {
                if ($actual.parent_cms_category_id == null) $actual.$$treeLevel = level;
                treeCmsCategories.push($actual);
                angular.forEach(cms_categories, function (cms_category) {
                    if (cms_category.parent_cms_category_id == $actual.id && cms_category.id != null) {
                        //recorremos el tree para decir que ya no es ultimo.
                        angular.forEach(treeCmsCategories, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(cms_category, level + 1);
                    }
                });
            };

            let otherGroup = "";
            //Obtenemos los padres
            angular.forEach(cms_categories, function (cms_category) {

                if (cms_category.parent_cms_category_id == null) {
                    if (cms_category.id != null) {
                        $l1.push(cms_category);
                    }
                }

            });

            //Pintamos
            angular.forEach($l1, function (cmsCategoryParent) {

                pintarRecursivo(cmsCategoryParent, 0);
            });

            return treeCmsCategories;
        },


        //Eventos
        eventsTree: function (events ,treeEvents) {
            let $l1 = [];
            function pintarRecursivo($actual, level) {
                if ($actual.parent_event_id == null) $actual.$$treeLevel = level;
                treeEvents.push($actual);
                angular.forEach(events, function (event) {
                    if (event.parent_event_id == $actual.id && event.id != null) {
                        //recorremos el tree para decir que ya no es ultimo.
                        angular.forEach(events, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(event, level + 1);
                    }
                });
            };

            let otherGroup = "";
            //Obtenemos los padres
            angular.forEach(events, function (event) {

                if (event.parent_event_id == null) {
                    if (event.id != null) {
                        $l1.push(event);
                    }
                }

            });

            //Pintamos
            angular.forEach($l1, function (eventParent) {

                pintarRecursivo(eventParent, 0);
            });

            return treeEvents;
        },

        resume_report: function (resume) {
            let tree = [];

            angular.forEach(resume, function (item) {
                let parent = { event_name: item.event_name, name: item.name, surname: item.surname, lastname: item.lastname, dni: item.dni, $$treeLevel: 0 };
                tree.push(parent);
                angular.forEach(item.monitoring, function (child) {
                    let children = { event_name: child/*, name: "", surname: "", lastname: "", dni: "", $$treeLevel: 1*/ };
                    tree.push(children);
                });

            });
            return tree;
        },


        tasksTree: function (tasks, eventTaskId, treeTasks) {
            let $l1 = [];

            function pintarRecursivo($actual, level) {
                if ($actual.task_id == null && $actual.is_group) $actual.$$treeLevel = level;
                $actual.hasTasks = false;
                treeTasks.push($actual);

                angular.forEach(tasks, function (taks) {
                    if (taks.task_id == $actual.id && taks.id != null && !taks.is_group) {
                        $actual.hasTasks = true;
                        //recorremos el tree para decir que ya no es ultimo.
                        angular.forEach(treeTasks, function (m) {
                            if (m.id == $actual.id) {
                                m.$$treeLevel = level;
                            }
                        });
                        return pintarRecursivo(taks, level + 1);
                    }
                });
            };


            let otherGroup = "";
            //Obtenemos los padres            
            angular.forEach(tasks, function (task) {
                if (task.is_group) {
                    if (task.id != null) {
                        $l1.push(task);
                    } else {
                        otherGroup = task;
                    }
                }
            });

            if (tasks.length > 0 && otherGroup != "") $l1.push(otherGroup);

            //Pintamos
            angular.forEach($l1, function (eventTaskParent) {
                pintarRecursivo(eventTaskParent, 0);
            });

            return treeTasks;
        },
    }

    return service;

}]);